import React, {useCallback} from "react";
import './OrgPage.scss';
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import OrgNoSlider from "./OrgNoSlider";
import LinkedIcon from '../../assets/svg/linked.svg';

const OrgPage: React.FC = () => {

    const [emblaRefOrg, emblaApiOrg] = useEmblaCarousel({loop: true}, [Autoplay({delay: 3000})]);

    const scrollPrev = useCallback(() => {
        if (!emblaApiOrg) return;
        emblaApiOrg.scrollPrev();
    }, [emblaApiOrg])
        
    const scrollNext = useCallback(() => {
        if (!emblaApiOrg) return;
        emblaApiOrg.scrollNext();
    }, [emblaApiOrg])

    return (
        <div className="org-page-container" id="scrollElement11">
            <h1 className="org-page-title document-main-title">Organizatori</h1>

            <OrgNoSlider></OrgNoSlider>

            <div className="org-holder org-mobile-version">

                <div className="org-carousel-container">
                    <div className="org-previous-button org-desktop-sliders" onClick={scrollPrev}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className='org-embla' ref={emblaRefOrg}>
                        <div className="org-embla-container">
                            <div className="org-embla-slide">
                                <h2 className="org-small-title">Glavni Organizator</h2>
                                <img src={'/images/coretim/MilaJovic.jpeg'} alt="Glavni Organizator" className="org-car-img"/>
                                
                            </div>

                            <div className="org-embla-slide">
                                <h2 className="org-small-title">Koordinator za odnose sa javnošću</h2>
                                {/*<img src={'/assets/images/coretim/UrosKovacevic.jpeg'} alt="PR" className="org-car-img"/>*/}
                                <h2 className="org-small-title no-caps">Uroš Kovačević</h2>

                            </div>

                            <div className="org-embla-slide">
                                <h2 className="org-small-title">Koordinator za odnose sa kompanijama</h2>
                                <img src={'/images/coretim/LukaRistic.jpeg'} alt="FR" className="org-car-img"/>
                                <h2 className="org-small-title no-caps">Marijana Aleksić</h2>
                            </div>

                            <div className="org-embla-slide">
                                <h2 className="org-small-title">Koordinator za Logistiku</h2>
                                <img src={'/images/coretim/VasilijePetrovic.jpeg'} alt="LOG" className="org-car-img"/>
                                <h2 className="org-small-title no-caps">Magdalena Vukomanović</h2>
                            </div>

                            <div className="org-embla-slide">
                                <h2 className="org-small-title">Koordinator za dizajn</h2>
                                <img src={'/images/coretim/KristinaDivac.jpeg'} alt="PUB" className="org-car-img"/>
                                <h2 className="org-small-title no-caps">Tijana Nedeljković</h2>
                            </div>

                            <div className="org-embla-slide">
                                <h2 className="org-small-title">Koordinator Seminara</h2>
                                <img src={'/images/coretim/AndjelaMatic.jpeg'} alt="KS" className="org-car-img"/>
                                <h2 className="org-small-title no-caps">Teodora Bužimkić</h2>
                            </div>
                        </div>
                    </div>
                    <div className="org-next-button org-desktop-sliders" onClick={scrollNext}>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="org-sliders-for-mobile">
                    <div className="org-previous-button" onClick={scrollPrev}>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="org-next-button" onClick={scrollNext}>
                        <span></span>
                        <span></span>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default OrgPage;